import { BRAND_COLORS } from "../../lib/bookingStatus";
export function HandbookHeader({
  de, properties, selected, setSelected, readOnly, editing,
  onEdit, onCancel, onSave, saving, onShare,
}) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const pdfHref = `${backendUrl}/api/properties/${selected.id}/handbook.pdf`;

  return (
    <div className="flex items-start justify-between gap-6 mb-10 flex-wrap">
      <div>
        <div className="label-caps mb-3">{de ? "Objekt-Wissenszentrale" : "Property knowledge hub"}</div>
        <h1 className="font-display text-4xl md:text-5xl text-navy">{de ? "Handbuch" : "Handbook"}</h1>
        <p className="text-[15px] text-navy-dark/70 mt-3 max-w-2xl">
          {de
            ? "WLAN, Heizung, Müllplan und Notfallkontakte — alles auf einen Blick für Sie, Ihre Familie und Ihre Gäste."
            : "Wi-Fi, heating, waste schedule and emergency contacts — everything at a glance for you, your family and your guests."}
        </p>
      </div>
      <div className="flex items-center gap-3">
        {properties.length > 1 && (
          <select
            data-testid="handbook-property-select"
            value={selected.id}
            onChange={(e) => setSelected(properties.find((p) => p.id === e.target.value))}
            className="bg-white border border-navy/20 px-4 py-2.5 text-navy-dark text-[13px] tracking-wider"
          >
            {properties.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        )}

        {!editing && (
          <a
            data-testid="handbook-pdf-btn"
            href={pdfHref}
            target="_blank"
            rel="noopener noreferrer"
            className="border border-navy text-navy px-5 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy hover:text-ivory transition-colors"
          >
            PDF-Export
          </a>
        )}

        {!readOnly && !editing && (
          <button
            data-testid="handbook-edit-btn"
            onClick={onEdit}
            className="border border-navy text-navy px-5 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy hover:text-ivory transition-colors"
          >
            {de ? "Bearbeiten" : "Edit"}
          </button>
        )}

        {!editing && (
          <button
            data-testid="handbook-share-btn"
            onClick={onShare}
            className="bg-navy text-ivory px-5 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors"
            style={{ background: BRAND_COLORS.navy }}
          >
            {de ? "Per E-Mail an Gast" : "Email to guest"}
          </button>
        )}

        {editing && (
          <>
            <button
              data-testid="handbook-cancel-btn"
              onClick={onCancel}
              className="text-[12px] tracking-[0.15em] uppercase text-navy-dark/60 hover:text-navy transition-colors"
            >
              {de ? "Abbrechen" : "Cancel"}
            </button>
            <button
              data-testid="handbook-save-btn"
              onClick={onSave}
              disabled={saving}
              className="bg-navy text-ivory px-5 py-2.5 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors disabled:opacity-50"
              style={{ background: BRAND_COLORS.navy }}
            >
              {saving ? "…" : (de ? "Speichern" : "Save")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
